import * as React from 'react';
import { ECounterPosition } from '@cian/frontend-fullscreen-carousel-component';
import { INewbuildingSummaryCellValue } from '../../../types/newbuildingsCompare';
import { MobileGalleryFooterContainer } from '../../MobileGalleryFooter';

export function getFullscreenOptions(newbuilding?: INewbuildingSummaryCellValue) {
  const fullscreenGallerySettings = [
    {
      minWidth: -Infinity,
      maxWidth: 641,
      options: {
        defaultControls: [],
        hideThumbnails: true,
        counterPosition: ECounterPosition.HEADER,
        contentOptions: {
          footerContent: <MobileGalleryFooterContainer newbuilding={newbuilding} />,
        },
      },
    },
    {
      minWidth: 641,
      maxWidth: Infinity,
      options: {
        defaultControls: [],
        hideThumbnails: true,
        counterPosition: ECounterPosition.HEADER,
        contentOptions: {
          footerContent: <MobileGalleryFooterContainer newbuilding={newbuilding} />,
        },
      },
    },
  ];

  return fullscreenGallerySettings;
}
